
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { CommomProps } from "./types";
import { useTranslation } from "react-i18next";
import { icons } from "../../../../../../../../../../utils/icons";
import { VIEW_TYPES } from "../../../../types/ViewTypes";
import { useStyles } from "./styles";
import { Status } from "../../../../../../../../../../utils/enums";
import { AnswerTypeHistory } from "../../../../enums/answerType";
import LightBulb from '../../../../../../../../../../assets/svg/mdi_lightbulb-on.svg'
import { CustomPaper } from "../../../../../../../../../../components/CustomPaper";
import { SolutionResponse } from "../solutionResponse";
import { AnswerItemsHistoria } from "../../../../types";
import { Dispatch, SetStateAction } from "react";


export const SolutionResponseList = ({ options, setOptions, onAttend, items, disabled, isMosaico, key, left, list, position, reload, setCurrentDataSolution, isList, setIsList }: CommomProps & {
  options: {
    id: number;
    label: string;
    value: string;
    check: boolean;
  }[];
  setOptions: Dispatch<SetStateAction<{
    id: number;
    label: string;
    value: string;
    check: boolean;
  }[]>>
}
) => {

  const { t } = useTranslation()
  const styles = useStyles();

  const lastQuote = items?.filter((item) => item.type === AnswerTypeHistory.SOLUTION).at(-1);
  const isApproved = lastQuote?.statusIdAnswer === Status.APPROVED;
  const isRejected = lastQuote?.statusIdAnswer === Status.REJECTED && lastQuote.commentApprovalAnswer == null;
  const isIntructionComment = !!lastQuote.instructionSubmitted;

  const addOtherSolution = () => {
    onAttend(VIEW_TYPES.SEND_SOLUTION)
  }

  const itemsChildren = lastQuote.answers.map((item: AnswerItemsHistoria) => ({
    answerSubmitted: lastQuote.answerSubmitted,
    instructionSubmitted: lastQuote.instructionSubmitted,
    instruction: lastQuote.instruction,
    statusIdAnswer: item.statusId,
    evidencesAnswer: item.evidences,
    evidencesRejectionAnswer: item.evidencesRejection,
    statusId: item.statusId,
    commentApprovalAnswer: item.commentApproval,
    evidencesApprovalAnswer: item.evidencesApproval,
    commentApprovalQuote: lastQuote.commentApprovalQuote,
    reasonOfRejectionQuote: lastQuote.reasonOfRejectionQuote,
    evidencesQuote: lastQuote.evidencesQuote,
    commentUpload: lastQuote.commentUpload,
    dateRequestManagement: lastQuote.dateRequestManagement,
    dateUploadQuote: lastQuote.dateUploadQuote,
    dateUploadSolution: item.createTime,
    newStep: lastQuote.newStep,
    idQuote: lastQuote.idQuote,
    type: lastQuote.type,
    usersAssings: lastQuote.usersAssings,
    descriptionAnswer: item.description,
    userUploadAnswer: lastQuote.userUploadAnswer,
    reasonOfRejectionAnswer: item.reasonOfRejection,
    userReviewerAnswer: item.reviewerUser,
    dateRequestCreateFolio: lastQuote.dateRequestCreateFolio,
    userManagersDeparment: lastQuote.userManagersDeparment,
  }))


  return (
    <Box>
      <Box sx={styles.containerHeader}>
        <Box sx={styles.dFlex}>
          <Box sx={styles.bulb}>
            <LightBulb />
          </Box>
          <Typography sx={styles.title}>{t(`reportFolio.detail.general.${isIntructionComment ? 'userCreatorSolutions' : 'userAssignedSolutions'}`)}</Typography>
        </Box>

        <Box>
          <Tooltip title={t('reportFolio.buttons.mosaico')}>
            <IconButton sx={styles.add(isList)} onClick={() => { setIsList(false) }}>
              {icons('mosaic')}
            </IconButton>
          </Tooltip>

          <Tooltip title={t('reportFolio.buttons.list')}>
            <IconButton sx={styles.add(!isList)} onClick={() => { setIsList(true) }}>
              {icons('list')}
            </IconButton>
          </Tooltip>

          {!isApproved && !isRejected &&
            <Tooltip title={t('reportFolio.buttons.addSolution')}>
              <IconButton sx={styles.add(false)} onClick={addOtherSolution}>
                {icons('add')}
              </IconButton>
            </Tooltip>
          }
        </Box>
      </Box>

      <CustomPaper elevation={3} sx={styles.paperC}>
        <Grid container spacing={3}>
          {itemsChildren.map((children:  any,  index:  number) => (
            <Grid key={children.id} item xl={isList ? 12 : 6} lg={isList ? 12 : 6} md={12} sm={12} xs={12}>
              <SolutionResponse options={options} setOptions={setOptions} setCurrentDataSolution={setCurrentDataSolution} disabled={disabled} isMosaico={!isList} items={[children]} left={left} list={true} onAttend={onAttend} position={index + 1} reload={reload} key={key} />
            </Grid>
          ))}
        </Grid>
      </CustomPaper>
    </Box>
  );
};
